export default __webpack_public_path__ + "static/media/profile-user.eaba3893.svg";